import API, { graphqlOperation } from "@aws-amplify/api";
import * as mutations from "../../graphql/mutations";
import * as queries from "../../graphql/queries";
import { makeGraphQLRequest } from "..";
const createDictionaryItem = async (object) => {
  try {
    const response = await makeGraphQLRequest(
      graphqlOperation(mutations.createDictionaryItem, { input: object })
    );
    return response.data.createDictionaryItem;
  } catch (error) {
    console.error("Error creating DictionaryItem:", error);
    throw error;
  }
};

const updateDictionaryItem = async (id, args) => {
  try {
    // First, fetch the current version of the DictionaryItem
    const getDictionaryItemResponse = await makeGraphQLRequest(
      graphqlOperation(queries.getDictionaryItem, { id })
    );
    const currentDictionaryItem =
      getDictionaryItemResponse.data.getDictionaryItem;

    // Prepare the update input
    const updateInput = { id, _version: currentDictionaryItem._version };
    args.forEach((arg) => {
      updateInput[arg.property] = arg.value;
    });

    const response = await makeGraphQLRequest(
      graphqlOperation(mutations.updateDictionaryItem, { input: updateInput })
    );
    return response.data.updateDictionaryItem;
  } catch (error) {
    console.error("Error updating DictionaryItem:", error);
    throw error;
  }
};

const deleteDictionaryItem = async (id) => {
  try {
    // First, fetch the current version of the DictionaryItem
    const getDictionaryItemResponse = await makeGraphQLRequest(
      graphqlOperation(queries.getDictionaryItem, { id })
    );
    const currentDictionaryItem =
      getDictionaryItemResponse.data.getDictionaryItem;

    return makeGraphQLRequest(
      graphqlOperation(mutations.deleteDictionaryItem, {
        input: { id, _version: currentDictionaryItem._version },
      })
    );
  } catch (error) {
    console.error("Error deleting DictionaryItem:", error);
    throw error;
  }
};

const getDictionariesByWorkspaceID = (workspaceID) =>
  makeGraphQLRequest(
    graphqlOperation(queries.dictionaryItemsByWorkspaceID, {
      workspaceID: workspaceID,
    })
  );

export default {
  createDictionaryItem,
  updateDictionaryItem,
  deleteDictionaryItem,
  getDictionariesByWorkspaceID,
};
